import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

function errorDetail(error) {
  if (isRouteErrorResponse(error)) {
    const status = `${error.status} ${error.statusText}`.trim();
    if (typeof error.data === 'string' && error.data.trim()) return `${status}: ${error.data}`;
    return status;
  }
  if (error instanceof Error) return error.message || error.name;
  if (typeof error === 'string') return error;
  return '';
}

/** Вместо английского экрана React Router. Текст ошибки — чтобы по скриншоту было видно, что упало. */
export default function RouteErrorPage() {
  const error = useRouteError();
  const detail = errorDetail(error);

  return (
    <div className="error-page route-error-page">
      <h2>Не удалось открыть страницу</h2>
      <p>
        Обновите страницу. Если после этого снова так же — пришлите преподавателю текст ошибки ниже.
      </p>
      <p className="route-error-actions">
        <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
          Обновить страницу
        </button>
        <a className="btn btn-outline" href="/">На главную</a>
      </p>
      {detail ? <pre className="route-error-detail">{detail}</pre> : null}
    </div>
  );
}
